import { forwardRef } from 'react'
import { AudioBlock, type CommonBlockProps } from '../../../types'
import { webchatClasses } from '../../../styles/classes'

type Props = AudioBlock & CommonBlockProps
export const Audio = forwardRef<HTMLAudioElement, Props>(({ url, isReadOnly, ...props }, ref) => {
  const {
    message: {
      blocks: { audio },
    },
  } = webchatClasses
  const preventNavigation = isReadOnly
    ? (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
      }
    : undefined
  return (
    <div>
      <audio {...props} controls onClick={preventNavigation} src={url} {...audio} ref={ref} />
    </div>
  )
})

Audio.displayName = 'Audio'
